
import DropdownActionItem from 'features/shared/components/dropdown/DropdownActionItem';
import { Commodity } from 'features/shared/enums/commodity';
import { getCommodityColorSuffix, getCommodityIcon } from 'features/shared/helpers/commodityHelper';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type Props = {
  onAddClick: (commodity: Commodity) => Promise<void>;
}

const AddContractingButton = ({ onAddClick }: Props) => {
  // translations
  const tLabels = useTranslation("contracting\\contracting").t;
  const tCommodities = useTranslation("shared\\enums\\commodity").t;

  // render
  return (
    <Dropdown>
      <Dropdown.Toggle id="add-contracting-dropdown" size='sm' variant='secondary' className='mt-3 mt-sm-0'>
        <span className="mr-1">
          {tLabels("contractingsSection.addContracting")}
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu >
        <DropdownActionItem 
          title={tCommodities(Commodity.Electricity)} 
          icon={getCommodityIcon(Commodity.Electricity)}
          color={getCommodityColorSuffix(Commodity.Electricity)}
          onClick={() => onAddClick(Commodity.Electricity)}
        />
        <DropdownActionItem
          title={tCommodities(Commodity.Gas)} 
          icon={getCommodityIcon(Commodity.Gas)}
          color={getCommodityColorSuffix(Commodity.Gas)}
          onClick={() => onAddClick(Commodity.Gas)}
        />
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default AddContractingButton;